import { Box, Grid } from '@mui/material'
import logoApp from '../../../images/Home/logoApp.png';
import property1 from '../../../images/Home/property1.png';
import property2 from '../../../images/Home/property2.png';
import property3 from '../../../images/Home/property3.png';
import svcEcogox from '../../../images/Home/svcEcogox.png';
import svcKarbonoa from '../../../images/Home/svcKarbonoa.png';
import svcEcorep from '../../../images/Home/svcEcorep.png';
import svcBiotrust from '../../../images/Home/svcBiotrust.png';
import svcEcotrade from '../../../images/Home/svcEcotrade.png';
import svcEcoWaas from '../../../images/Home/svcEcoWaas.png'
import './StyledHome.css'
import Footer from '../footer/Footer';

const Home = () => {
  return (
    <>
      <Grid className='backGroundSection1'>
        <img className='logoApp' src={logoApp} alt="" />
        <Grid container>
          <Grid item md={8} xs={12}>
            <h3>Soluciones tecnológicas para la acción climática.</h3>
          </Grid>
        </Grid>
      </Grid>
      <Grid className='backGroundSection2'>
        <Grid container className='containerBriefcase'>
          <Grid item md={12} xs={12}>
            <h1>Portafolio de tecnologías flexibles.</h1>
          </Grid>
          <Grid item md={12} xs={12} className='itemDescription'>
            <p>A partir de la ciencia, la tecnología, la experiencia y la experimentación, creamos nuevas
              soluciones diseñadas para ser usadas y aplicadas de manera sencilla, logrando así que nuestros
              productos, generen valor sostenible para <strong>mejorar la vida en el planeta.</strong></p>
          </Grid>
        </Grid>
        <Grid container spacing={2} className='containerProperties'>
          <Grid item md={4} xs={12}>
            <h1>Propiedades</h1>
          </Grid>
          <Grid item md={8} xs={12}>
            <Grid item container spacing={3}>
              <Grid item md={4} xs={12}>
                <img src={property1} alt="" />
              </Grid>
              <Grid item md={4} xs={12}>
                <img src={property2} alt="" />
              </Grid>
              <Grid item md={4} xs={12}>
                <img src={property3} alt="" />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid className='backGroundSection3'>
        <Grid container className='products'>
          <Grid item md={12} xs={12}>
            <h1>Nuestros productos</h1>
          </Grid>
        </Grid>
        <Grid item md={12} xs={12}>
          <a href='https://www.ecogox.com/' target="_blank">
            <img src={svcEcogox} style={{ maxWidth: '100%', height: 'auto', marginBottom: '-4px' }} alt="" />
          </a>
          <img src={svcKarbonoa} style={{ maxWidth: '100%', height: 'auto', marginBottom: '-4px' }} alt="" />
          <a href='https://appf-ecorep-dev-01.azurewebsites.net/home' target="_blank">
            <img src={svcEcorep} style={{ maxWidth: '100%', height: 'auto', marginBottom: '-4px' }} alt="" />
          </a>
          <a href='https://biotrust.com.co/' target="_blank">
            <img src={svcBiotrust} style={{ maxWidth: '100%', height: 'auto', marginBottom: '-4px' }} alt="" />
          </a>
          <a href='https://eco-trade.com.co' target="_blank">
            <img src={svcEcotrade} style={{ maxWidth: '100%', height: 'auto', marginBottom: '-4px' }} alt="" />
          </a>
          <img src={svcEcoWaas} style={{ maxWidth: '100%', height: 'auto', marginBottom: '-4px' }} alt="" />
        </Grid>
      </Grid>
      <Grid md={12} xs={12}>
        <Footer />
      </Grid>
    </>
  )
}

Home.propTypes = {}

export default Home
